import React, { Component } from "react";
import aiSvg from "../../assests/images/dump/ai_colored.svg";

export default class DataScienceImg extends Component {
  render() {
    return (
      <div style={{ 
        width: '100%', 
        height: 'auto', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        padding: '20px'
      }}>
        <img 
          src={aiSvg} 
          alt="AI & Machine Learning Illustration"
          style={{ 
            maxWidth: '90%', 
            height: 'auto',
            display: 'block'
          }}
        />
      </div>
    );
  }
}
